(function ($, Promise) {

		// Constructor
		function OffScreenRender(width, height, resolution, customScene) {

			this.width = width;
			this.height = height;

			// Init scene
			this.scene = new THREE.Scene();
			this.scene.background = new THREE.Color(0x000000);

			// Init camera
			// this.camera = new THREE.OrthographicCamera(-(width / 2), (width / 2), (height / 2), -(height / 2), 1, 1000);
			this.camera = new THREE.OrthographicCamera(0, (this.width), 0, (this.height), 0.1, 2000);
			this.camera.position.set(0, 0, 200);
			// this.camera.lookAt(0, 0, 0);

			// Init ouptut sprite on which is displayed the output
			if (customScene == false) {
				this.sprite = this.createMesh(width, height);
				this.sprite.position.set(0, 0, -200)
				this.scene.add(this.sprite);
			}

			this.camera.updateProjectionMatrix();

			// Init render target texture
			this.bufferTexture = new THREE.WebGLRenderTarget(width * resolution, height * resolution, {
				wrapS: THREE.ClampToEdgeWrapping,
				wrapT: THREE.ClampToEdgeWrapping,
				minFilter: THREE.NearestFilter,
				magFilter: THREE.NearestFilter,
				depthBuffer: false,
			});
			this.bufferMaterial = new THREE.MeshBasicMaterial({map: this.bufferTexture.texture});
		}

		OffScreenRender.prototype.setShader = function (material) {
			this.sprite.material = material;
		}

		OffScreenRender.prototype.getTexture = function () {
			return this.bufferTexture.texture;
		}

		OffScreenRender.prototype.createMesh = function (width, height) {

			var geometry = new THREE.PlaneGeometry(width, height);
			geometry.scale(-1, -1, 1);
			geometry.rotateY(-Math.PI)
			geometry.translate(width / 2, height / 2, 0)
			return new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({color: 0xFF0000, side: THREE.DoubleSide}));

			// var geometry = new THREE.BufferGeometry();
			// var float32Array = new Float32Array([
			//   0, 0, 0, 0, 0,
			//   width, 0, 0, 1, 0,
			//   width, height, 0, 1, 1,
			//   0, height, 0, 0, 1,
			// ]);
			// var interleavedBuffer = new THREE.InterleavedBuffer(float32Array, 5);
			// geometry.setIndex([0, 1, 2, 0, 2, 3]);
			// geometry.addAttribute('position', new THREE.InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
			// geometry.addAttribute('uv', new THREE.InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
			// return new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({color: 0xFF0000, side: THREE.DoubleSide}));
		}

		OffScreenRender.prototype.createOutputMaterial = function () {
			return new THREE.MeshBasicMaterial({map: this.bufferTexture.texture, transparent: true});
		}

		OffScreenRender.prototype.render = function (renderer) {
			renderer.setRenderTarget(this.bufferTexture);
			renderer.clear();
			renderer.render(this.scene, this.camera);
			renderer.setRenderTarget(null);
			// renderer.clear();
		}

		// Expose OffScreenRender
		window.OffScreenRender = OffScreenRender;
	}
)
(jQuery, Promise);
